export enum VisitStatus {
  NEW = "NEW",
  FLOATING = "FLOATING",
  IN_PROGRESS = "IN_PROGRESS",
  BOOKED = "BOOKED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  REFERRED = "REFERRED",
  AUTO = "AUTO"
}
